import { call, put, takeEvery } from 'redux-saga/effects';
import { getBikeBrands } from '../../requests/get_bike_brands_request';
import { getBikeBrandsSuccess, getBikeBrandsFailure } from '../actions/get_bike_brands.actions';
import { GET_BIKE_BRANDS_REQUEST } from '../constants/get_bike_brands.constants';

function* getBikeBrandsRequest({ params }) {
    const brands = yield call(getBikeBrands, params); const
        { msg, options } = brands;

    brands
        ? yield put(getBikeBrandsSuccess(options))
        : yield put(getBikeBrandsFailure(msg));
}

export default function* getBikeBrandsSaga() {
    yield takeEvery(GET_BIKE_BRANDS_REQUEST, getBikeBrandsRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/redux/sagas/get_bike_brands.saga.js